import { fireEvent } from '@stitch-fix/kufak-gtm-client';
import trackProductEvent from '../../utils/trackProductEvent';

// this event should fire when a customer clicks on the Buy Now button on the Ungated PDP

// eslint-disable-next-line import/prefer-default-export
export const trackBuyNowClick = ({
  allSkusOutOfStock,
  selectedSkuId,
  externalProductId,
  recommendedCollections,
  isSkuOutOfStock,
  isSkuLimitedStock,
  subSource,
  skipEventTracking,
}) => {
  if (skipEventTracking) {
    return;
  }

  const relatedItemSkuIds = recommendedCollections
    ?.find(collection => collection?.treatment === 'similar_items')
    ?.shopProducts?.nodes?.map(item => item.variantBySkuId?.id);

  const eventName = 'ungated.pdp';
  const canonicalName = 'pdp';
  const actionType = 'click';
  const actionName = 'buy_now';
  const actionDetail = 'ungated_shop';
  const directBuyContext = {
    shopping_context: null,
    outfit_id: null,
    external_product_id: externalProductId,
    related_item_sku_ids: relatedItemSkuIds || [],
    sku_id: selectedSkuId,
    sub_source: subSource,
    source: 'ungated_shop',
    all_items_out_of_stock: allSkusOutOfStock,
    on_screen: {
      out_of_stock: isSkuOutOfStock,
      limited_stock: isSkuLimitedStock,
      hide_item: false,
    },
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};

export const trackGtmBuyNowButtonClick = state => {
  if (state.skipEventTracking) {
    return;
  }
  // NOTE: all attributes are optionally-chained as we never want problems with
  //       this event to cause issues with the page or purchases.
  fireEvent({
    eventName: 'buy_now_button_click',
    eventAttributes: {
      revenue: state.formattedPrice.replace('$', ''),
      business_line: state.productBusinessLine,
      external_product_id: state.externalProductId,
      sku_id: state.selectedSkuId,
      pdp_type: 'ungated',
    },
  });
};
